/* eslint-disable no-useless-catch */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/hooks';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Alert,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { passwordReset } from '../../auth/slice';
import routes from '@/constants/routes';

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Correo no válido').required('Campo requerido'),
});

const ResetPassword = () => {
  const [emailSent, setEmailSent] = useState(false);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { email: '' },
    validationSchema: validationSchema,
    onSubmit: async ({ email }) => {
      try {
        await dispatch(passwordReset(email));
        setEmailSent(true);
      } catch (error) {
        throw error;
      }
    },
  });

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 4,
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <Stack gap={2}>
          <Typography variant="h1">Cambia tu contraseña</Typography>
          {emailSent ? (
            <Alert color="success" severity="success">
              Email sent, check your inbox!
            </Alert>
          ) : null}
          <TextField
            name="email"
            type="email"
            label="Correo"
            margin="normal"
            value={formik.values.email}
            onChange={formik.handleChange}
          />
          <Button size="large" variant="contained" type="submit">
            Cambiar contraseña
          </Button>
          <Button
            size="large"
            variant="outlined"
            onClick={() => navigate(routes.login)}
          >
            Iniciar Sesión
          </Button>
        </Stack>
      </form>
    </Box>
  );
};

export default ResetPassword;
